import { IContactFunctionData } from '../../types/contacts/IContactFunctionData';
import { ISelectOption } from '../../ui-toolkit';

export const getContactFunctionValue = (
  values: string[] = [],
  contactFunctions?: IContactFunctionData[]
): ISelectOption[] => {
  return values.map((value) => ({
    label: contactFunctions?.find((func) => func.id === value)?.label ?? '',
    value: value,
  }));
};
